import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { updateCookieLifespan } from "./cookies";

const connectionString =
  document
    .querySelector('meta[name="application-insights-connection-string"]')
    ?.getAttribute("content") ?? undefined;

const instrumentationKey =
  document
    .querySelector('meta[name="application-insights-instrumentation-key"]')
    ?.getAttribute("content") ?? undefined;

const applicationVersion =
  document.querySelector('meta[name="application-version"]')?.getAttribute("content") ??
  undefined;

if (connectionString || instrumentationKey) {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      instrumentationKey,
      cookieCfg: {
        setCookie: (name, value) => {
          // Modify the ai_user cookie to have 6 months expiration date instead of 1 year, as per
          // request from MARS.
          if (name === "ai_user") {
            const sixMonths = 6 * 30 * 24 * 60 * 60;

            updateCookieLifespan("ai_user", sixMonths, { cookieValue: value });
          } else {
            document.cookie = `${name}=${value}`;
          }
        }
      }
    }
  });

  appInsights.loadAppInsights();

  if (applicationVersion) {
    // Tag all client telemetry with the deployed version (ai.application.ver), matching the
    // server-side VersionTelemetryInitializer.
    appInsights.context.application.ver = applicationVersion;
  }

  appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

  // Expose the instance so other bundles can send custom telemetry (see app-insights-telemetry.ts)
  window.appInsights = appInsights;
} else {
  console.warn(
    "Application Insights connection string or instrumentation key not found."
  );
}
